import { CheckoutDTO } from "./checkout.dto";

export class StepDTO {
    user: string | undefined;
    data: {
        form: CheckoutDTO | undefined;
    } | undefined;
}